import type { TStaffAvailability, TStaffAwayReason } from '@/services/staff';

import { AWAY_REASON_LABEL, CONCIERGES_COPY } from '@/constants/concierges';
import { toDayMonth } from '@/utils/date';

type TAvailabilityState = {
  availability: TStaffAvailability;
  awayReason: TStaffAwayReason | null;
  awayUntil: string | null;
};

const toAvailabilityLabel = (state: TAvailabilityState): string => {
  if (state.availability === 'inactive') {
    return CONCIERGES_COPY.inactive;
  }

  if (state.availability === 'active') {
    return '';
  }

  const reason = state.awayReason ? AWAY_REASON_LABEL[state.awayReason] : '';
  const until = state.awayUntil ? `${CONCIERGES_COPY.until} ${toDayMonth(state.awayUntil)}` : '';

  return [CONCIERGES_COPY.away, [reason, until].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(CONCIERGES_COPY.separator);
};

export type {
  TAvailabilityState,
};
export {
  toAvailabilityLabel,
};
